// extracted by mini-css-extract-plugin
export default {"main":"about_main__5RBFk","myImg":"about_myImg__um9yU","content":"about_content__gVOL8","skillsSlider":"about_skillsSlider__JFk0K"};